import { set, toggle } from '@/utils/vuex'

const state = {
  drawer: null,
  mini: false,
  image: 'public/img/background-drawer-jpg'
}

const mutations = {
  setDrawer: set('drawer'),
  setImage: set('image'),
  toggleDrawer: toggle('drawer'),
  toggleMini: toggle('mini')
}

export default {
  state,
  mutations
}
